/**
 * OrbDocCoreConceptsStandardLibraryAROrbDocCoreConceptsStandardLibraryARPage
 *
 * Page component for OrbDocCoreConceptsStandardLibraryAROrbDocCoreConceptsStandardLibraryARPage
 * Path: /ar/docs/core-concepts/standard-library
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsStandardLibraryARDocScreenView as __OrbDocCoreConceptsStandardLibraryARDocScreenView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryARDocScreenView';
import { OrbDocCoreConceptsStandardLibraryARDocAnalyticsView as __OrbDocCoreConceptsStandardLibraryARDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsStandardLibraryAROrbDocCoreConceptsStandardLibraryARPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsStandardLibraryAROrbDocCoreConceptsStandardLibraryARPage(_props: OrbDocCoreConceptsStandardLibraryAROrbDocCoreConceptsStandardLibraryARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"المكتبة القياسية","description":"مئات السلوكيات، من القوائم والنماذج إلى الألعاب وأدوات التعلّم، جاهزة للاستيراد والربط.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/standard-library"},{"locale":"ar","path":"/ar/docs/core-concepts/standard-library"},{"locale":"sl","path":"/sl/docs/core-concepts/standard-library"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsStandardLibraryARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsStandardLibraryARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsStandardLibraryAROrbDocCoreConceptsStandardLibraryARPage;
